// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.
import tasks from './project-checklist-task-templates.js';

export default [
    {
        path: '/:organisation/projects/project-templates/:id/project-checklist-templates/archive',
        component: () =>
            import('@/pages/[organisation]/projects/project-templates/[id]/project-checklist-templates/archive.vue'),
        name: 'project-management.project-checklist-templates.archived-project-checklist-templates',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-checklist-templates.update-project-checklist-template',
        },
        children: [
            {
                path: ':checklistId',
                component: () =>
                    import('@/pages/[organisation]/projects/project-templates/[id]/project-checklist-templates/archive/[checklistId].vue'),
                name: 'project-management.project-checklist-templates.view-archived-project-checklist-template',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project-checklist-templates.update-project-checklist-template',
                },
            },
        ],
    },

    {
        path: '/:organisation/projects/project-templates/:id/project-checklist-templates/bin',
        component: () =>
            import('@/pages/[organisation]/projects/project-templates/[id]/project-checklist-templates/bin.vue'),
        name: 'project-management.project-checklist-templates.binned-project-checklist-templates',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-checklist-templates.archive-project-checklist-templates',
        },
        children: [
            {
                path: ':checklistId',
                component: () =>
                    import('@/pages/[organisation]/projects/project-templates/[id]/project-checklist-templates/bin/[checklistId].vue'),
                name: 'project-management.project-checklist-templates.view-binned-project-checklist-template',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project-checklist-templates.archive-project-checklist-templates',
                },
            },
        ],
    },

    {
        path: '/:organisation/projects/project-templates/:id/project-checklist-templates',
        component: () =>
            import('@/pages/[organisation]/projects/project-templates/[id]/project-checklist-templates.vue'),
        name: 'project-management.project-checklist-templates.search-project-checklist-templates',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-checklist-templates.view-project-checklist-templates',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/projects/project-templates/[id]/project-checklist-templates/new.vue'),
                name: 'project-management.project-checklist-templates.create-project-checklist-template',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project-checklist-templates.create-project-checklist-template',
                },
            },
            {
                path: ':checklistId',
                component: () =>
                    import(/* webpackChunkName: "project-management.project-checklist-templates" */ '@/pages/[organisation]/projects/project-checklist-templates/project-checklist-template/[id].vue'),
                name: 'project-management.project-checklist-templates.view-project-checklist-template',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project-checklist-templates.view-project-checklist-templates',
                },
            },
            {
                path: ':checklistId/edit',
                component: () =>
                    import(/* webpackChunkName: "project-management.project-checklist-templates" */ '@/pages/[organisation]/projects/project-checklist-templates/project-checklist-template/[id]/edit.vue'),
                name: 'project-management.project-checklist-templates.update-project-checklist-template',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project-checklist-templates.update-project-checklist-template',
                },
            },
            ...tasks,
        ],
    },
];
